export function isRouterLinkProps(props) {
  return Object.prototype.hasOwnProperty.call(props, 'to') && Boolean(props.to);
}